import { api } from '../../shared/api/client';
import type {
  DashboardKpisDto,
  DashboardKpisQuery,
  DashboardPendingDto,
  DashboardTrendDto,
  DashboardTrendQuery,
} from './types';

/**
 * GeneXus serializa `bas:Numeric` como JSON string quando `Length > 4`
 * (Long Numeric pra evitar overflow do safe integer). O contrato atual do
 * `ApiDashboard` mantém todos os contadores em `Num(4,0)` justamente pra
 * cair em JSON number, mas a normalização aqui fica como safety net caso
 * algum atributo escale no futuro (Length>4) ou um Domain novo apareça.
 */
function toInt(value: unknown): number {
  if (typeof value === 'number') return value;
  if (typeof value === 'string' && /^-?\d+$/.test(value)) return Number(value);
  return 0;
}

function normalizeKpis(raw: DashboardKpisDto): DashboardKpisDto {
  return {
    ...raw,
    ano: toInt(raw.ano),
    mes: toInt(raw.mes),
    nfsPendentes: toInt(raw.nfsPendentes),
    colaboradoresAtivos: toInt(raw.colaboradoresAtivos),
  };
}

function normalizeTrend(raw: DashboardTrendDto): DashboardTrendDto {
  return {
    meses: toInt(raw.meses),
    pontos: raw.pontos.map((p) => ({ ...p, ano: toInt(p.ano), mes: toInt(p.mes) })),
  };
}

export async function getDashboardKpis(query: DashboardKpisQuery): Promise<DashboardKpisDto> {
  const { data } = await api.get<{ data: DashboardKpisDto }>('/v1/dashboard/kpis', {
    params: query,
  });
  return normalizeKpis(data.data);
}

export async function getDashboardPending(): Promise<DashboardPendingDto> {
  const { data } = await api.get<{ data: DashboardPendingDto }>('/v1/dashboard/pending');
  return data.data;
}

export async function getDashboardTrend(query: DashboardTrendQuery): Promise<DashboardTrendDto> {
  const { data } = await api.get<{ data: DashboardTrendDto }>('/v1/dashboard/trend', {
    params: query,
  });
  return normalizeTrend(data.data);
}
